/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_Learnmoreorganization2Inputs */

const zh_share_learnmoreorganization2 = /** @type {(inputs: Share_Learnmoreorganization2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`组织：组织内所有成员均可访问。`)
};

const en_share_learnmoreorganization2 = /** @type {(inputs: Share_Learnmoreorganization2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organization: All members of the organization can access.`)
};

const es_share_learnmoreorganization2 = /** @type {(inputs: Share_Learnmoreorganization2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organización: Todos los miembros de la organización pueden acceder.`)
};

/**
* | output |
* | --- |
* | "Organization: All members of the organization can access." |
*
* @param {Share_Learnmoreorganization2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const share_learnmoreorganization2 = /** @type {((inputs?: Share_Learnmoreorganization2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_Learnmoreorganization2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_share_learnmoreorganization2(inputs)
	if (locale === "en") return en_share_learnmoreorganization2(inputs)
	return es_share_learnmoreorganization2(inputs)
});
export { share_learnmoreorganization2 as "share_learnMoreOrganization" }